import React from 'react';
import { ServiceStatus } from '../types';
import './SystemHealth.css';

const systemServices: ServiceStatus[] = [
  {
    name: 'CloudFront CDN',
    status: 'healthy',
    details: 'Distribution active, 99.9% uptime',
    icon: '🌐',
    lastChecked: new Date().toLocaleTimeString(),
  },
  {
    name: 'WebSocket API',
    status: 'healthy',
    details: 'API Gateway WebSocket endpoint active',
    icon: '🔌',
    lastChecked: new Date().toLocaleTimeString(),
  },
  {
    name: 'DynamoDB',
    status: 'healthy',
    details: 'All tables operational, auto-scaling enabled',
    icon: '🗄️',
    lastChecked: new Date().toLocaleTimeString(),
  },
  {
    name: 'Lambda Functions',
    status: 'healthy',
    details: 'All functions deployed, avg latency < 100ms',
    icon: '⚡',
    lastChecked: new Date().toLocaleTimeString(),
  },
  {
    name: 'S3 Storage',
    status: 'healthy',
    details: 'Bucket accessible, static assets served',
    icon: '📦',
    lastChecked: new Date().toLocaleTimeString(),
  },
];

export const SystemHealth: React.FC = () => {
  const allHealthy = systemServices.every(s => s.status === 'healthy');

  return (
    <div className="admin-system">
      <div className="admin-system__header">
        <h2 className="admin-system__title">System Health</h2>
        <span className={`admin-system__overall admin-system__overall--${allHealthy ? 'healthy' : 'degraded'}`}>
          {allHealthy ? '✅ All Systems Operational' : '⚠️ Some Issues Detected'}
        </span>
      </div>

      <div className="admin-system__grid">
        {systemServices.map((service, index) => (
          <div key={index} className={`admin-system__card admin-system__card--${service.status}`}>
            <div className="admin-system__card-header">
              <span className="admin-system__card-icon">{service.icon}</span>
              <span className={`admin-system__status-dot admin-system__status-dot--${service.status}`} />
            </div>
            <h3 className="admin-system__card-name">{service.name}</h3>
            <p className="admin-system__card-details">{service.details}</p>
            <span className="admin-system__card-time">
              Last checked: {service.lastChecked}
            </span>
          </div>
        ))}
      </div>

      <div className="admin-system__note">
        <p>
          ℹ️ System health data is based on static configuration. For real-time monitoring,
          integrate with AWS CloudWatch or a health check endpoint.
        </p>
      </div>
    </div>
  );
};
